<template>
    <div class="demo-inline-spacing">
        <Button
            class="mt-0"
            @click="save"
            :disabled="isSaveDisabled"
        >
            {{ $t('Component(Button):save') }}
        </Button>
        <Button
            class="mt-0"
            @click="close"
        >
            {{ $t('Component(Button):close') }}
        </Button>
    </div>
</template>

<script>
import Button from "@core/components/common/Button.vue";

export default {
    components: {
        Button,
    },
    props: {
        isSaveDisabled: {
            default: false
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save');
        },
    }
}
</script>

<style scoped>

</style>
